export const DESCRIPTIVE_SHOWCASE = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.DescriptiveShowcaseWidgetElement';
